// context/ProfileImageContext.tsx
import React, { createContext, useContext, useState, useCallback } from "react";
import avatarDefault from "../assets/images/users/avatar-1.jpg";
import coverDefault from "../assets/images/small/img-4.jpg";
import { apiCore } from "../api/apiCore";
import * as url from "../api/urls";


const STORAGE_KEY_AVATAR = "profileAvatar";
const STORAGE_KEY_COVER = "profileCover";

interface ProfileImageContextType {
  avatarImage: string;
  coverImage: string;
  updateAvatar: (img: string | null) => void;
  updateCover: (img: string | null) => void;

  postAvatarProfile: (idUser: number, base64: string) => void;
  postCoverProfile: (idUser: number, base64: string) => void;
}

const ProfileImageContext = createContext<ProfileImageContextType | null>(null);

export const ProfileImageProvider = ({ children }: { children: React.ReactNode }) => {

  const [avatarImage, setAvatarImage] = useState<string>(() =>
    localStorage.getItem(STORAGE_KEY_AVATAR) || avatarDefault
  );

  const [coverImage, setCoverImage] = useState<string>(() =>
    localStorage.getItem(STORAGE_KEY_COVER) || coverDefault
  );

  const updateAvatar = useCallback((img: string | null) => {
    const finalImage = img || avatarDefault;
    localStorage.setItem(STORAGE_KEY_AVATAR, finalImage);
    setAvatarImage(finalImage);
  }, []);


  const updateCover = useCallback((img: string | null) => {
    const finalImage = img || coverDefault;
    localStorage.setItem(STORAGE_KEY_COVER, finalImage);
    setCoverImage(finalImage);
  }, []);

  const postAvatarProfile = useCallback(async (id: number, base64: string) => {
    const result = await apiCore<string>(`${url.API_USER_AVATAR}`, {
      method: "POST",
      body: JSON.stringify({ idUser: id, base64: base64 }),
    });
    if (result.status === 200)
      console.log('result OK');
  }, []);

  const postCoverProfile = useCallback(async (id: number, base64: string) => {
    const result = await apiCore<string>(`${url.API_USER_COVER}`, {
      method: "POST",
      body: JSON.stringify({ idUser: id, base64: base64 }),
    });
    if (result.status === 200)
      console.log('result OK');
  }, []);


  return (
    <ProfileImageContext.Provider
      value={{ avatarImage, coverImage, updateAvatar, updateCover, postAvatarProfile, postCoverProfile }}
    >
      {children}
    </ProfileImageContext.Provider>
  );
};

export const useProfileImage = () => {
  const ctx = useContext(ProfileImageContext);
  if (!ctx) {
    throw new Error("useProfileImage must be used inside ProfileImageProvider");
  }
  return ctx;
};
